var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472,395.4V116.6c23.3-8.3,40-30.5,40-56.6c0-33.1-26.9-60-60-60s-60,26.9-60,60c0,26.1,16.7,48.3,40,56.6V236 H276V116.6c23.3-8.3,40-30.5,40-56.6c0-33.1-26.9-60-60-60s-60,26.9-60,60c0,26.1,16.7,48.3,40,56.6V236H60c-11,0-20,9-20,20v139.4 C16.7,403.7,0,425.9,0,452c0,33.1,26.9,60,60,60s60-26.9,60-60c0-26.1-16.7-48.3-40-56.6V276h156v119.4c-23.3,8.3-40,30.5-40,56.6 c0,33.1,26.9,60,60,60s60-26.9,60-60c0-26.1-16.7-48.3-40-56.6V276h156v119.4c-23.3,8.3-40,30.5-40,56.6c0,33.1,26.9,60,60,60 s60-26.9,60-60C512,425.9,495.3,403.7,472,395.4z M60,472c-11,0-20-9-20-20s9-20,20-20s20,9,20,20S71,472,60,472z M256,472 c-11,0-20-9-20-20s9-20,20-20c11,0,20,9,20,20S267,472,256,472z M256,80c-11,0-20-9-20-20s9-20,20-20c11,0,20,9,20,20S267,80,256,80 z M452,40c11,0,20,9,20,20s-9,20-20,20s-20-9-20-20S441,40,452,40z M452,472c-11,0-20-9-20-20s9-20,20-20s20,9,20,20 S463,472,452,472z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmission);
export default __webpack_public_path__ + "static/media/transmission.1cf0b9a0984570cf6de06426b37a7cda.svg";
export { ForwardRef as ReactComponent };